export type GameResultReceipts = Record<
  string,
  Record<string, { acceptedAt: number }>
>
export function normalizeGameResultReceipts(
  value: unknown,
): GameResultReceipts {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return {}
  const receipts: GameResultReceipts = Object.create(null) as GameResultReceipts
  for (const [owner, entries] of Object.entries(value)) {
    if (!entries || typeof entries !== 'object' || Array.isArray(entries))
      continue
    const valid: Record<string, { acceptedAt: number }> = Object.create(
      null,
    ) as Record<string, { acceptedAt: number }>
    for (const [id, row] of Object.entries(entries))
      if (
        row &&
        typeof row === 'object' &&
        'acceptedAt' in row &&
        typeof row.acceptedAt === 'number' &&
        Number.isFinite(row.acceptedAt) &&
        row.acceptedAt >= 0
      )
        valid[id] = { acceptedAt: row.acceptedAt }
    receipts[owner] = valid
  }
  return receipts
}
